import React from "react";
import { Instagram, Facebook, Linkedin, Music2 } from "lucide-react";

const SOCIALS = [
  { Icon: Instagram, label: "Instagram", url: "https://www.instagram.com/motravaymu/", color: "bg-gradient-to-tr from-amber-500 via-rose-500 to-fuchsia-600" },
  { Icon: Facebook, label: "Facebook", url: "https://www.facebook.com/motravay.mu", color: "bg-[#1877F2]" },
  { Icon: Linkedin, label: "LinkedIn", url: "https://www.linkedin.com/company/motravay/", color: "bg-[#0A66C2]" },
  { Icon: Music2, label: "TikTok", url: "https://www.tiktok.com/@motravay", color: "bg-black" },
];

export default function StatsSection() {
  const stats = [
    { value: "200+", label: "Companies hiring" },
    { value: "65,000+", label: "Applications received" },
    { value: "160,000+", label: "Followers on social media" },
  ];
  return (
    <section className="bg-white border-y border-slate-100 py-14" data-testid="stats-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {stats.map(s => (
            <div key={s.label} data-testid={`stat-${s.label}`}>
              <div className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight">{s.value}</div>
              <div className="mt-2 text-xs uppercase tracking-[0.25em] text-slate-500">{s.label}</div>
            </div>
          ))}
        </div>
        <div className="mt-10 flex items-center justify-center gap-3">
          <span className="text-xs uppercase tracking-[0.25em] text-slate-500 mr-2">Follow us</span>
          {SOCIALS.map(({ Icon, label, url, color }) => (
            <a
              key={label}
              href={url}
              target="_blank"
              rel="noreferrer"
              aria-label={label}
              data-testid={`social-${label.toLowerCase()}`}
              className={`h-10 w-10 rounded-full text-white flex items-center justify-center transition-all ${color} hover:-translate-y-0.5 hover:opacity-90 shadow-sm`}
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
